module.exports = __webpack_public_path__ + "img/Postmodernisme_Andre_kunstformer1.528ccdbf.jpg";